export default {
  balanceBoxAmountText: 'dt.payments.components.balanceBoxAmountText',
  balanceBoxTypeText: 'dt.payments.components.balanceBoxTypeText',
};
